module.exports = __webpack_public_path__ + "assets/img/technologyImg5.09579aa8.png";